import { useMemo } from "react";
import { MODULES, RECURRING, ESTIMATE_NOTES } from "../data/site";
import { Reveal } from "./atoms";

const money = (n) => `$${n.toLocaleString("en-US")}`;

export default function EstimateTable({ light = false }) {
  const total = useMemo(() => MODULES.reduce((s, m) => s + m.price, 0), []);

  const line = light ? "border-gray-200" : "border-linec";
  const headText = light ? "text-gray-500" : "text-dim";
  const title = "text-navy";

  return (
    <div data-testid="estimate-table">
      <Reveal className={`border ${line} rounded-lg overflow-hidden bg-white`}>
        <div className={`hidden md:grid grid-cols-[3rem_1fr_9rem] gap-4 px-6 py-4 border-b ${line} ${headText} font-mono text-[10px] tracking-[0.25em] uppercase`}>
          <span>#</span><span>MODULE</span><span>PRICE</span>
        </div>
        {MODULES.map((m) => (
          <div key={m.n} data-testid={`estimate-module-row-${m.n}`}
            className={`grid md:grid-cols-[3rem_1fr_9rem] gap-2 md:gap-4 px-6 py-6 border-b ${line} last:border-b-0 items-start`}>
            <span className="font-mono text-xs pt-1 text-ember">{m.n}</span>
            <div>
              <h4 className={`font-body font-semibold ${title} text-lg`}>{m.name}</h4>
              <p className={`text-sm mt-1 leading-relaxed ${light ? "text-gray-600" : "text-mutedx"}`}>{m.desc}</p>
            </div>
            <span className="font-mono text-sm font-bold text-ember md:text-right">{money(m.price)}</span>
          </div>
        ))}
        <div className={`grid md:grid-cols-[3rem_1fr_9rem] gap-2 md:gap-4 px-6 py-5 bg-mist border-t ${line} items-center`}>
          <span />
          <h4 className={`font-body font-bold ${title} text-lg`}>Total — not-to-exceed</h4>
          <span className="font-mono text-lg font-bold text-ember md:text-right" data-testid="estimate-nte-amount">{money(total)}</span>
        </div>
        <div className={`grid md:grid-cols-[3rem_1fr_9rem] gap-2 md:gap-4 px-6 py-4 border-t ${line} items-center bg-white`} data-testid="estimate-recurring-row">
          <span className="font-mono text-xs text-ember">+</span>
          <div>
            <h4 className={`font-body font-semibold ${title} text-sm`}>{RECURRING.name}</h4>
            <p className={`text-xs mt-0.5 leading-relaxed ${light ? "text-gray-600" : "text-mutedx"}`}>{RECURRING.note}</p>
          </div>
          <span className="font-mono text-sm font-bold text-ember md:text-right">{money(RECURRING.price)}/yr</span>
        </div>
      </Reveal>

      <Reveal className="mt-6 space-y-2">
        {ESTIMATE_NOTES.map((n, i) => (
          <p key={i} className={`text-sm leading-relaxed flex gap-3 ${light ? "text-gray-600" : "text-mutedx"}`}>
            <span className="text-ember font-mono">0{i + 1}</span>{n}
          </p>
        ))}
      </Reveal>
    </div>
  );
}
